export enum API_V2_TOGGLES {
  GP_SEARCH = "gpSearch",
  INVOICE = "invoice",
  CREATE_DOCTOR_VISIT = "createDoctorVisit",
  NEARBY_DOCTOR_SEARCH = "nearbyDoctorSearch",
  MHA_FORMS = "mhaforms",
}
